import { Chip } from '@mui/material';

const RenderChip = ({ val }) => {
    let label = '';
    let color = '';
    if (val === 'complete') {
        label = 'Completed';
        color = 'success';
    } else if (val === 'in-progress') {
        label = 'In progress';
        color = 'primary';
    } else if (val === 'dlp') {
        label = 'DLP';
        color = 'warning';
    } else if (val === 'cancelled') {
        label = 'Cancelled';
        color = 'warning';
    } else if (val === 'deferred') {
        label = 'Deferred';
        color = 'warning';
    } else {
        label = 'To be launched';
        color = 'warning';
    }
    return <Chip label={label} color={color} />;
};

export default RenderChip;
